module.exports = __webpack_public_path__ + "static/media/logo-villum.aa2d4606.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/img/logo-villum.png
// module id = 1486
// module chunks = 0